import React from "react";
import BankAccountCard from "./BankAccountCard";

const BankAccountList = ({ accounts, onEdit, onDelete }) => {
  return (
    <div className="grid">
      {accounts.map((account) => (
        <div key={account.id} className="col-12 md:col-4">
          <BankAccountCard account={account} onEdit={onEdit} onDelete={onDelete} />
        </div>
      ))}
    </div>
  );
};

export default BankAccountList;
